'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelPerformanceTracker = exports.endPerformanceTracker = exports.startPerformanceTracker = exports.PerformanceTrackAction = undefined;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _CwLog = require('../services/CwLog');

var _CwLog2 = _interopRequireDefault(_CwLog);

var _StreamLogger = require('../services/StreamLogger');

var _Store = require('../services/Store');

var _Store2 = _interopRequireDefault(_Store);

var _ModuleReducer = require('../components/module/ModuleReducer');

var _ScreenReducer = require('../components/screen/ScreenReducer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Enum for Performance Track Type
 * @readonly
 * @enum {string}
 */
var PerformanceTrackAction = exports.PerformanceTrackAction = {
  EXECUTE: 'Execute',
  RENDER: 'Render',
  SERVER_REQUEST: 'ServerRequest',
  CLIENT_ACTION: 'ClientAction'
};

var performanceTracks = {}; // {string: PerformanceTrack}

/**
 * Starts and stores performance tracking event
 * @param {string} name 
 * @param {string} action 
 * @param {string} [amazonTraceId] - optional guid that uniquely identifies this request
 */
var startPerformanceTracker = exports.startPerformanceTracker = function startPerformanceTracker(name, action, amazonTraceId) {

  if (performanceTracks[name]) {
    _CwLog2.default.warn('Attempting to start an already started performance tracker! Ignoring request. Please make sure your tracker key is unique.');
    return;
  }

  var state = (0, _Store2.default)().getState();
  var screenKey = (0, _ModuleReducer.getActiveScreenKey)(state.module);
  var pt = (0, _ScreenReducer.getScreenPerformanceTrack)(state.screen, screenKey);

  if (!(pt && pt.get)) {
    _CwLog2.default.warn('Failed to get Performance Track. Ignoring request.');
    return;
  }

  /** @type {PerformanceTrack} */
  var performanceTrack = {
    name: name,
    action: action,
    clientAction: pt.get('name'),
    clientActionId: pt.get('id'),
    startTime: (0, _moment2.default)(),
    amazonTraceId: amazonTraceId
  };

  performanceTracks[name] = performanceTrack;
};

/**
 * Ends and logs a performance tracking event
 * @param {string} name 
 * @param {any} custom 
 */
var endPerformanceTracker = exports.endPerformanceTracker = function endPerformanceTracker(name) {
  var custom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;


  /** @type {PerformanceTrack} */
  var performanceTrack = performanceTracks[name];

  if (!performanceTrack) {
    return;
  }

  performanceTrack.endTime = (0, _moment2.default)();
  performanceTrack.elapsedTime = performanceTrack.endTime.valueOf() - performanceTrack.startTime.valueOf();
  performanceTrack.custom = custom;

  // clear performance track
  delete performanceTracks[name];

  // log performance tracking event
  (0, _StreamLogger.addPerformanceTrackerEvent)(performanceTrack);
};

/**
 * Cancels and removes an in-progress performance tracking event
 * @param {string} name 
 */
var cancelPerformanceTracker = exports.cancelPerformanceTracker = function cancelPerformanceTracker(name) {
  // clear performance track
  delete performanceTracks[name];
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/PerformanceTracker.js
// module id = 818
// module chunks = 10